module.exports = __webpack_public_path__ + "static/img/cont3.63a0d5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3.jpg
// module id = Pfkg
// module chunks = 0